// extracted by mini-css-extract-plugin
export var progressBar = "_nb-0";
export var progressBarInner = "_nb-1";